<template>
  <v-row>
    <v-col class="col-12 pt-0">
      <h2 class="text-center font-weight-black" :class="font">{{ text }}</h2>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "AppHeading",
  props: {
    text: {
      type: String,
      required: true
    },
    heading: {
      type: String
    }
  },
  computed: {
    font() {
      let font;
      if (this.heading == "main") {
        font = "headline";
      } else {
        font = "title";
      }
      return font;
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 18px !important;
}
</style>
